export var RuleFormTab;
(function (RuleFormTab) {
    RuleFormTab["InfoAndTriggers"] = "infoAndTriggers";
    RuleFormTab["CurateResults"] = "curateResults";
    RuleFormTab["Ranking"] = "ranking";
    RuleFormTab["Navigations"] = "navigations";
    RuleFormTab["Facets"] = "facets";
    RuleFormTab["Content"] = "content";
    RuleFormTab["RuleExperiment"] = "ruleExperiment";
    RuleFormTab["Analytics"] = "analytics";
})(RuleFormTab || (RuleFormTab = {}));
export const TAB_NAMES = [
    RuleFormTab.InfoAndTriggers,
    RuleFormTab.CurateResults,
    RuleFormTab.Ranking,
    RuleFormTab.Navigations,
    RuleFormTab.Facets,
    RuleFormTab.Content,
];
export const RULE_VARIANT_TAB_NAMES = [
    RuleFormTab.CurateResults,
    RuleFormTab.Ranking,
    RuleFormTab.Navigations,
    RuleFormTab.Content,
];
export const RULE_FORM_TAB_NAMES_TO_MESSAGE_KEY = {
    [RuleFormTab.InfoAndTriggers]: 'INFO_AND_TRIGGERS',
    [RuleFormTab.CurateResults]: 'RECALL',
    [RuleFormTab.Ranking]: 'RANKING',
    [RuleFormTab.Navigations]: 'FACETS',
    [RuleFormTab.Facets]: 'FACETS',
    [RuleFormTab.Content]: 'RULE_TAB_CONTENT',
    [RuleFormTab.RuleExperiment]: 'EXPERIMENT',
    [RuleFormTab.Analytics]: 'ANALYTICS',
};
export { VARIANT_MAX_LIMIT, VARIANT_MIN_LIMIT, RuleDragType } from '@/shared/rule/rule-form.constants';
export { HISTORY_KEYS } from '@/shared/rule/rule-form.history.constants';
